import {
  RiArrowDownSLine,
  RiArrowRightSLine,
  RiArrowUpSLine,
} from "react-icons/ri";
import TableJobDescription from "./TableJobDescription";
import { useEffect, useState } from "react";

const jobRequirementsData = [
  {
    id: 1,
    text: "Candidate should have relevant 03+ years of experience in his nature of Job.",
  },
  {
    id: 2,
    text: "Candidate must be below 35 years of age.",
  },
  {
    id: 3,
    text: "Candidate should be physically fit & healthy. ",
  },
  {
    id: 4,
    text: "Candidate need to work anywhere in Saudi Arabia as per company requirement.",
  },
];

export default function JobDescription({ setData }) {
  const [show, setShow] = useState(false);
  const [formatedJobDescription, setFormatedJobDescription] = useState([]);
  const [jobRequirements, setJobRequirnments] = useState(jobRequirementsData);

  const updateJobRequirenments = (jr) => {
    setJobRequirnments(jr);
  };

  useEffect(() => {
    const copyiedJobDesc = [...jobRequirements];
    let newDesc = [];
    copyiedJobDesc.forEach((item) => {
      newDesc.push({ description: item.text });
    });
    setData((prev) => ({
      ...prev,
      job_description: newDesc,
    }));
  }, [jobRequirements]);

  const JOB_REQUIREMENTS = jobRequirements.map((item) => {
    return {
      description: item,
    };
  });
  //call setData
  // setData(JOB_REQUIREMENTS,'jobDescription')

  return (
    <div className="flex flex-wrap gap-4 ">
      <div className=" w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Job Description</h2>
          <p>Provide Job Descriptions.</p>
        </div>
      </div>
      <div
        className={`w-full m-2 overflow-hidden px-4 rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <button
          type="button"
          className="bg-red text-white p-2 rounded-md mt-2 ml-2"
          onClick={() => {
            setJobRequirnments((prev) => [
              ...prev,
              { id: Math.floor(Math.random() * 10000), text: "" },
            ]);
          }}
        >
          + Add Another
        </button>
        <TableJobDescription
          jobRequirements={jobRequirements}
          updateJobRequirenments={updateJobRequirenments}
          setFormatedJobDescription={setFormatedJobDescription}
        />
      </div>
    </div>
  );
}
